<template>
    <div>
        <div class="modal__first">
            <div class="backdrop" v-if="backgroundActive" @click="handleDisclosureLink(isAffiliate)"></div>
            <div class="modal__first--shimer" v-if="loading">
                <section class="header__f">
                    <div class="title__header">
                        <h2></h2>
                        <div class="subtitles">
                        </div>
                    </div>
                    <div></div>
                </section>
                <section class="body__f">
                    <div class="body__left">
                        <img class="banner"/>
                        <p></p>
                    </div>

                    <div class="body__center">
                        <div class="first">
                            <h3></h3>
                            <h3></h3>
                        </div>
                        <div class="second">
                            <h3></h3>
                            <h3></h3>
                            <h3></h3>
                        </div>
                        <div class="third">
                            <h3></h3> 
                        </div>
                    </div>
                    <div class="body__right">
                        <div class="buy__out">
                            <h3></h3>
                            <a class="button buy" target="_blank"></a>
                        </div>
                        <div class="disclose__item">
                            <a class="button disclose"></a>
                        </div>

                    </div>
                </section>
                <section class="footer__f">
                    <div class="footer__f__in first">
                        <article>
                            <span></span>
                            <span></span>
                        </article>
                        <article>
                            <span></span>
                            <span></span>
                        </article>
                        <article>
                            <span></span>
                            <span></span>
                        </article>
                        <article>
                            <span></span>
                            <span></span>
                        </article>
                    </div>
                </section>
            </div>


            <div v-if="!loading">
                <section class="header__f">
                    <div class="title__header">
                        <h2 v-html="allData.name"></h2>
                        <div class="subtitles">
                            <!-- ID {{allData.hash}}
                            &nbsp;•&nbsp; -->
                            Criado por&nbsp;
                            <a v-html="allData.actualVersion.name"></a> 
                            <!-- &nbsp;•&nbsp; -->
                            <!-- <a>Ver mais produtos deste(a) vendedor(a)</a> -->
                        </div>
                    </div>
                    <div></div>
                    <!-- <a class="button report" href="">Denunciar esse Produto</a> -->
                </section>
                <section class="body__f">
                    <div class="body__left">
                        <img class="banner" loading="lazy" :src="allData.actualVersion.image ? allData.actualVersion.image.url : '/internacional/public/office4/img/supercheckout-intern/ic-placeholder.png'" />
                        <p v-html="allData.description"></p>
                    </div>

                    <div class="body__center">
                        <div class="first">
                            <span v-html="t.label_commission_until"></span>
                            <span>{{allData.actualVersion.config_affiliation.level1}}%</span>
                        </div>
                        <div class="second">
                            <div v-html="t.label_the_maximum_price_for_this_product_is">
                            </div>
                            <span v-html="handleValue(allData.actualVersion.currency, allData.actualVersion.total)"></span>
                            <div v-html="t.label_for_each_sale"></div>
                        </div>
                        <div class="third">
                            <h3 v-html="t.label_this_product_is_commissioned_at_the_last_click"></h3> 
                        </div>
                    </div>
                    <div class="body__right">
                        <div class="buy__out">
                            <h3 v-html="t.label_want_to_buy_this_product"></h3>
                            <a class="button buy" target="_blank" :href="allData.actualVersion.purchase_url + '?aid_bg=' + idUpline" v-html="t.label_buy_this_product"></a>
                        </div>
                        <div class="disclose__item">
                            <a class="button disclose" @click="handleDisclosureLink(isAffiliate)" v-html="t.label_promote_this_product"></a>
                            <div class="links" v-if="showDisclosuresLink">
                                <div class="links__header">
                                    <div class="icon">
                                        <svg width="20" height="10" viewBox="0 0 20 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1.9 5C1.9 3.29 3.29 1.9 5 1.9H9V0H5C2.24 0 0 2.24 0 5C0 7.76 2.24 10 5 10H9V8.1H5C3.29 8.1 1.9 6.71 1.9 5ZM6 6H14V4H6V6ZM15 0H11V1.9H15C16.71 1.9 18.1 3.29 18.1 5C18.1 6.71 16.71 8.1 15 8.1H11V10H15C17.76 10 20 7.76 20 5C20 2.24 17.76 0 15 0Z" fill="#0080FC"/>
                                        </svg>
                                    </div>
                                    <span v-html="t.label_copy_link_to_advertise_product"></span>
                                </div>
                                <div class="inputs">
                                    <input
                                        type="text"
                                        :value="allData.actualVersion.purchase_url + '?aid_bg=' + idUser"
                                        :id="['input-disclosure-product']"
                                    />
                                    <a
                                        class="button copy__v2"
                                        :data-clipboard-target="['#input-disclosure-product']"
                                        data-labelCopy="copied" v-html="t.label_copy_link"></a>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
                <section class="footer__f">
                    <div class="footer__f__in first">
                        <article>
                            <span v-html="t.label_language"></span>
                            <span v-html="handleShowLenguage(allData.actualVersion.language)"></span>
                        </article>
                        <article>
                            <span v-html="t.label_support_email"></span>
                            <span v-html="allData.actualVersion.email_producer"></span>
                        </article>
                        <article>
                            <span v-html="t.label_access_form"></span>
                            <span v-html="allData.format"></span>
                        </article>
                        <article>
                            <span v-html="t.label_format"></span>
                            <span v-html="allData.niche"></span>
                        </article>
                        <!-- <article>
                            <span>Assunto</span> -->
                            <!-- <span v-html="allData.actualVersion."></span> -->
                            <!-- <span>Internet e Design</span> -->
                        <!-- </article> -->
                    </div>
                    <!-- <div class="footer__f__in second"> -->
                        <!-- <article> -->
                            <!-- <span>Lançamento</span> -->
                            <!-- <span v-html="allData.actualVersion."></span> -->
                            <!-- <span>30.02.1950</span> -->
                        <!-- </article>
                        <article>
                            <span>Vendido</span> -->
                            <!-- <span v-html="allData.actualVersion."></span> -->
                            <!-- <span>1.250</span> -->
                        <!-- </article>
                        <article>
                            <span>EPC</span> -->
                            <!-- <span v-html="allData.actualVersion."></span> -->
                            <!-- <span>R$ 1,25</span> -->
                        <!-- </article>
                        <article>
                            <span>Conversão</span> -->
                            <!-- <span v-html="allData.actualVersion."></span> -->
                            <!-- <span>1.250 %</span> -->
                        <!-- </article>
                        <article>
                            <span>Preço médio</span> -->
                            <!-- <span v-html="allData.actualVersion."></span> -->
                            <!-- <span>Preço médio</span> -->
                        <!-- </article>
                    </div> -->
                </section>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "super-checkout-intern-modal-firstTab",
    props: ["view", "haveAffiliation", "idUser", "modalCardSelectedID", "idUpline"],
    data(){
        return {
            t: this.$parent.view.translation,
            backgroundActive: false,
            showDisclosuresLink: false,
            loading: false,
            isAffiliate: false,
            allData: {
                actualVersion: {
                    name: null,
                    checkout_page: null,
                    config_affiliation: {
                        level1: 0
                    },
                    currency: null,
                    email_producer: null,
                    hash: null,
                    image: {
                        url: null
                    },
                    name: null,
                    purchase_url: null,
                    sales_page: null,
                    total: null,
                }
            }
        }
    },

    mounted () {
        this.allData = null;
        this.handleAllData();
        if(this.haveAffiliation) this.isAffiliate = true;
        // console.log(this.view);
        // console.log('modal',this.$parent.view.translation);
    },

    methods: {
        handleAllData() {
            var vm = this;
            vm.loading = true;
            axios.get(
                `${this.$parent.$parent.view.routes.rota_office_super_checkout_intern_request}/${this.modalCardSelectedID}`,
            )
            .then(function (response) {
                // handle success
                // console.log(1,response);
                vm.loading = false;
                vm.allData = response.data.product;
                vm.allData.actualVersion = response.data.product.versions[response.data.product.versions.length-1];
                // console.log(1,vm.allData);
            })
            .catch(function (error) {
                // handle error
                console.log(2,error);
            })
        },
        handleDisclosureLink(checkIsAffiliate) {
            // if(checkIsAffiliate) {
                this.backgroundActive = !this.backgroundActive;
                this.showDisclosuresLink = !this.showDisclosuresLink;
            // } else {
                // $('#modal-upgrade-by-tool').modal('show'); //modals.phtml
            // }
        },
        handleValue(currency, value) {
            if(currency == 'USD') return `$ ${value/100}.`;
            if(currency == 'BRL') return `R$ ${value/100}.`;
            if(currency == 'EUR') return `€ ${value/100}.`;
        },
        handleShowLenguage(language) {
            if(language == 'pt-br') return 'Português';
            if(language == 'en-us') return 'English';
            if(language == 'es-es') return 'Español';
            if(language == 'it-it') return 'Italian';
        }
    },

    computed: {
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .backdrop {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: black;
        opacity: 0.5;
    }
    .modal__first {
        .button {
            padding: 1.4rem 2rem;
            color: white;
            border-radius: 4px;
            transition: .16s all ease;
            &:hover {
                box-shadow: 0 0 10px -5px black;
            }
        }
        .header__f {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: .7rem;
            margin-bottom: 1rem;
            border-bottom: 1px solid rgba(0, 0, 0, 0.2);
            .title__header {
                h2 {
                    margin: 0;
                    font-size: 2rem;
                    font-weight: 600;
                    margin-bottom: .6rem;
                }
            }
            .subtitles {
                font-size: .86rem;
                display: flex;
                align-items: center;
                justify-content: start;
                a {
                    font-size: 1em;
                    color: #0080FC;
                    &:first-child {
                        font-weight: 600;
                    }
                }
            }
            a.report {
                background: #FA754B;
            }
        }

        .body__f {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            .body__left {
                padding: 0 1rem;
                border-right: 1px solid rgba(0, 0, 0, 0.1);
                display: flex;
                flex-direction: column;
                img {
                    margin: .5rem auto;
                    max-width: 300px;
                }
                p {
                    color: #5B5B5B;
                    line-height: 18px;
                    font-size: .9rem;
                }
            }
            .body__center {
                display: flex;
                flex-direction: column;
                padding: 0 1rem;
                .first {
                    display: flex;
                    flex-direction: column;
                    font-weight: 600;
                    font-size: 1.2rem;
                    span {
                        font-weight: 300;
                        &:last-child {
                            font-weight: 300;
                            font-size: 5rem;
                            color: #4FAEF6;
                            margin-top: .7rem;
                        }
                    }
                }
                .second {
                    margin: 1rem 0;
                    padding: 1rem 0;
                    border-top: 1px solid rgba(0, 0, 0, 0.2);
                    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
                    display: flex;
                    flex-direction: column;
                    span {
                        margin: .7rem 0;
                        font-weight: 600;
                        color: #14C51B;
                        font-size: 2rem;
                    }
                }
            }
            .body__right {
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: center;
                .buy__out {
                    background: rgba(196, 196, 196, 0.14);
                    border: 1px solid #14C51B;
                    border-radius: 4px;
                    padding: 2rem 1rem;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    h3 {
                        margin-bottom: 1rem;
                    }
                    .buy {
                        background: #14C51B;
                        text-transform: uppercase;
                        display: flex;
                        font-size: .9rem;
                    }
                }
                .disclose__item {
                    position: relative;
                    .disclose {
                        display: flex;
                        align-items: center;
                        color: #0080FC;
                        box-shadow: 0px 0px 9px rgba(38, 36, 36, 0.161);
                    }
                    .links {
                        position: absolute;
                        background: white;
                        padding: 2rem;
                        border-radius: 4px;
                        width: 40vw;
                        left: -39vw;
                        top: -28vh;
                        .links__header {
                            display: flex;
                            align-items: center;
                            margin-bottom: 1rem;
                            .icon {
                                padding: 12px 10px;
                                border: 1px solid #0080FC;
                                border-radius: 30px;
                                margin-right: 1rem;
                            }
                            span {
                                font-weight: 600;
                            }
                        }
                        .inputs {
                            display: flex;
                            justify-content: space-between;
                            input {
                                padding: .4rem 3rem;
                                background: rgba(102, 179, 255, 0.5);
                                border-radius: 4px;
                                border: none;
                                font-weight: 600;
                                margin-right: 1rem;
                                flex: 1;
                            }
                            .copy__v2 {
                                background: #0080FC;
                                padding: .8rem 1rem;
                            }
                        }
                    }
                }
            }
        }

        .footer__f {
            .footer__f__in {
                display: grid;
                grid-template-columns: repeat(5, 1fr);
                margin: 1rem 0;
                padding: 1.4rem 0;
                &.first {
                   border-bottom: 1px solid rgba(0, 0, 0, 0.2);
                   border-top: 1px solid rgba(0, 0, 0, 0.2);
                }
                article {
                    display: flex;
                    flex-direction: column;
                    // margin-right: 2rem;
                    span {
                        &:first-child {
                            color: black;
                            font-weight: 600;
                            margin-bottom: .1rem;
                        }
                    }
                }
            }
        }
    }



    //shimmer loader
    @keyframes placeHolderShimmer{
        0%{
            background-position: -468px 0
        }
        100%{
            background-position: 468px 0
        }
    }
    .modal__first--shimer {
        padding: 1rem;
        cursor: pointer;
        transition: .2s all;
        .header__f .title__header h2,
        .header__f .title__header .subtitles,
        .body__f .body__center .first h3,
        .body__f .body__center .second h3,
        .body__f .body__center .first h3,
        .body__f .body__left p,
        .footer__f .footer__f__in article span,
        .body__f .body__right .buy__out,
        .body__f .body__right .buy__out h3,
        .body__f .body__right .buy__out .buy,
        .body__f .body__right .disclose__item .disclose {
            animation-duration: 1.25s;
            animation-fill-mode: forwards;
            animation-iteration-count: infinite;
            animation-name: placeHolderShimmer;
            animation-timing-function: linear;
            background: linear-gradient(to right, #edf1f5 8%, #f3f6f9 18%, #edf1f5 33%);
            background-size: 800px 104px;
            position: relative;
            border-radius: 4px;
        }

        .button {
            padding: 1.4rem 2rem;
            color: white;
            border-radius: 4px;
            transition: .16s all ease;
            height: 40px;
            &:hover {
                box-shadow: 0 0 10px -5px black;
            }
        }
        .header__f {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: .7rem;
            margin-bottom: 1rem;
            border-bottom: 1px solid rgba(0, 0, 0, 0.2);
            .title__header {
                h2 {
                    height: 30px;
                    width: 320px;
                }
            }
            .subtitles {
                height: 30px;
                width: 320px;
            }
            a.report {
                background: #FA754B;
            }
        }

        .body__f {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            .body__left {
                padding: 0 1rem;
                border-right: 1px solid rgba(0, 0, 0, 0.1);
                display: flex;
                flex-direction: column;
                // img {
                //     height: 150px;
                //     width: 300px;
                // }
                p {
                    height: 150px;
                    width: 300px;
                }
            }
            .body__center {
                display: flex;
                flex-direction: column;
                padding: 0 1rem;
                .first {
                    h3 {
                        height: 30px;
                        width: 100%;
                        margin-bottom: .2rem;
                    }
                }
                .second {
                    h3 {
                        height: 30px;
                        width: 100%;
                        margin-bottom: .2rem;
                    }
                }
                .third {
                    h3 {
                        height: 30px;
                        width: 100%;
                        margin-bottom: .2rem;
                    }
                }
            }
            .body__right {
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: center;
                .buy__out {
                    border: none;
                    border-radius: 4px;
                    padding: 2rem 1rem;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    width: 200px;
                    h3 {
                        height: 30px;
                        width: 150px;
                        margin-bottom: 1rem;
                    }
                    .buy {
                        text-transform: uppercase;
                        display: flex;
                        font-size: .9rem;
                    }
                }
                .disclose__item {
                    position: relative;
                    .disclose {
                        display: flex;
                        align-items: center;
                        color: #0080FC;
                        width: 200px;
                    }
                    .links {
                        position: absolute;
                        background: white;
                        padding: 2rem;
                        border-radius: 4px;
                        width: 40vw;
                        left: -39vw;
                        top: -28vh;
                        .links__header {
                            display: flex;
                            align-items: center;
                            margin-bottom: 1rem;
                            .icon {
                                padding: 12px 10px;
                                border: 1px solid #0080FC;
                                border-radius: 30px;
                                margin-right: 1rem;
                            }
                            span {
                                font-weight: 600;
                            }
                        }
                        .inputs {
                            display: flex;
                            justify-content: space-between;
                            input {
                                padding: .4rem 3rem;
                                background: rgba(102, 179, 255, 0.5);
                                border-radius: 4px;
                                border: none;
                                font-weight: 600;
                                margin-right: 1rem;
                                flex: 1;
                            }
                            .copy__v2 {
                                background: #0080FC;
                                padding: .8rem 1rem;
                            }
                        }
                    }
                }
            }
        }

        .footer__f {
            .footer__f__in {
                display: grid;
                grid-template-columns: repeat(5, 1fr);
                margin: 1rem 0;
                padding: 1.4rem 0;
                &.first {
                   border-bottom: 1px solid rgba(0, 0, 0, 0.2);
                   border-top: 1px solid rgba(0, 0, 0, 0.2);
                }
                article {
                    display: flex;
                    flex-direction: column;
                    span {
                        height: 20px;
                        width: 100%;
                        margin: 2px 0;
                    }
                }
            }
        }

    }







    @media (max-width: 1230px) {
        .modal__first .body__f .body__right .disclose__item .links {
            width: unset;
        }
    }
    @media (max-width: 1100px) {
        .modal__first {
            .header__f {
                flex-direction: column;
                justify-content: center;
                a.report {
                    margin-top: 1rem;
                }
            }
            .body__f {
                grid-template-columns: 1fr;
                text-align: center;
                .body__left {
                    border: none;
                    img {
                        max-width: 100%;
                    }
                }
                .body__right {
                    .buy__out {
                        margin-bottom: 1rem;
                    }
                    .disclose__item .links {
                        left: -7vw;
                    }
                }
            }
            .footer__f {
                .footer__f__in {
                    grid-template-columns: 1fr;
                    text-align: center;
                    article {
                        margin-bottom: 1rem;
                    }
                }
            }
        }
    }
    @media (max-width: 450px) {
        .modal__first {
            .header__f .subtitles {
                flex-direction: column;
                font-size: 1.04rem;
                text-align: center;
                a {
                    text-align: center;
                    &:first-child {
                        margin-top: .3rem;
                    }
                }
            }
        }
    }
    @media (max-width: 450px) {
        .modal__first {
            .body__f .body__right {
                .disclose__item .links {
                    left: -12vw;
                    .inputs {
                        flex-direction: column;
                        input {
                            margin: 0;
                        }
                        .button {
                            margin-top: 1rem;
                        }
                    }
                }
                .disclose__item .links {
                    left: -7vw;
                }
            }
        }
    }
    @media (max-width: 400px) {
        .modal__first {
            .body__f .body__right .disclose__item .links {
                left: -15vw;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/super-checkout-intern/modal/firstTab.vue